import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <InviteDesign />
    </React.StrictMode>,
);

function InviteDesign() {
    const uuid = window.location.pathname.split('/').filter(Boolean)[0];
    const designSrc = uuid ? `/design1.html?uuid=${encodeURIComponent(uuid)}` : '/design1.html';

    return (
        <main className="page">
            <iframe
                className="design-frame"
                title="Пригласительное 4"
                src={designSrc}
            />
        </main>
    );
}